import React from 'react'
import { Alert } from '@mui/material'
import type { BudgetBanner as BudgetBannerState } from '../../utils/budgetBanner'

interface BudgetBannerProps {
  banner: BudgetBannerState | null
  onDismiss: () => void
}

/** A slim, one-line banner at the top of the page about the team's AI budget. */
const BudgetBanner: React.FC<BudgetBannerProps> = ({ banner, onDismiss }) => {
  if (!banner) return null
  return (
    <Alert
      severity={banner.severity}
      variant="standard"
      onClose={onDismiss}
      data-testid="budget-banner"
      sx={{ borderRadius: 0, py: 0, alignItems: 'center' }}
    >
      {banner.text}
    </Alert>
  )
}

export default BudgetBanner
